import { createPlanOrderApi, verifyPlanPaymentApi } from "../config/Api";

const CHECKOUT_SCRIPT = 'https://checkout.razorpay.com/v1/checkout.js'

// load Razorpay's checkout script once, when a payment starts
const loadCheckout = () => new Promise((resolve, reject) => {
    if (window.Razorpay) return resolve()
    const script = document.createElement('script')
    script.src = CHECKOUT_SCRIPT
    script.onload = () => resolve()
    script.onerror = () => reject(new Error('Could not load the payment window. Check your internet connection.'))
    document.body.appendChild(script)
})

/**
 * Pay for a plan: the backend creates the order (and decides the amount), Razorpay Checkout takes the
 * payment, and the backend verifies it.
 *
 * Resolves with { paid: true, message } when the plan is active, or { paid: false, message } when the
 * window was closed or the payment is still being confirmed ("I've paid, check status" covers that).
 */
export const payForPlan = async (planId, cycle) => {
    await loadCheckout()
    const { data } = await createPlanOrderApi(planId, cycle)
    const order = data.data

    return new Promise((resolve, reject) => {
        const checkout = new window.Razorpay({
            key: order.key_id,
            order_id: order.order_id,
            amount: order.amount_paise,
            currency: order.currency,
            name: 'Nutri Nexus',
            description: `${order.plan_name} plan, ${order.cycle}`,
            prefill: { name: order.name, email: order.email, contact: order.phone || '' },
            theme: { color: '#5F4B8B' },
            handler: (response) => {
                verifyPlanPaymentApi(response)
                    .then((res) => resolve({ paid: true, message: res.data.message }))
                    .catch(reject)
            },
            modal: {
                ondismiss: () => resolve({
                    paid: false,
                    message: "Payment window closed. If you completed the payment, use \"I've paid, check status\".",
                }),
            },
        })
        checkout.on('payment.failed', (response) => {
            // Razorpay lets the user retry in the same window; this only reports the failed attempt
            console.warn('Payment attempt failed', response?.error?.description)
        })
        checkout.open()
    })
}
